import { render } from "./DsoAffiliate.vue?vue&type=template&id=bd1cd8c6&scoped=true"
import script from "./DsoAffiliate.vue?vue&type=script&lang=js"
export * from "./DsoAffiliate.vue?vue&type=script&lang=js"

import "./DsoAffiliate.vue?vue&type=style&index=0&id=bd1cd8c6&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd1cd8c6"]])

export default __exports__